import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  topRow: {
    marginBottom: theme.spacing(2),
  },
  escrowAmountsContainer: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    height: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
    },
  },
  rootContainer: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
  noLoansContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    width: '100%',
    height: '60vh',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      height: '40vh',
      textAlign: 'center',
    },
  },
  subTitle: {
    color: theme.palette.tab.offselected,
    fontWeight: 500,
    marginBottom: theme.spacing(1)
  },
  noLoansText: {
    color: theme.palette.tab.offselected,
    fontWeight: 500,
    textAlign: 'center'
  },
  placeholderText: {
    color: theme.palette.tab.offselected,
    fontWeight: 500,
    textAlign: 'center',
    marginTop: theme.spacing(5)
  },
}));
